const C = ({
  features: e,
  loginMethod: a
}) => y("use_feature", e, a), p = ({
  cartId: e,
  products: a,
  loginMethod: t,
  partnerName: o,
  features: n
}) => r(
  "view_cart",
  e,
  a,
  o,
  n,
  t
), w = ({
  cartId: e,
  addedProducts: a,
  loginMethod: t,
  partnerName: o,
  features: n
}) => r(
  "add_to_cart",
  e,
  a,
  o,
  n,
  t
), h = ({
  cartId: e,
  products: a,
  removedProductIds: t,
  loginMethod: o,
  partnerName: n,
  features: c
}) => r(
  "remove_from_cart",
  e,
  u(a, t),
  n,
  c,
  o
), d = ({
  cartId: e,
  products: a,
  loginMethod: t,
  partnerName: o,
  features: n
}) => r(
  "begin_checkout",
  e,
  a,
  o,
  n,
  t
), k = ({
  cartId: e,
  products: a,
  loginMethod: t,
  partnerName: o,
  features: n
}) => r(
  "add_payment_info",
  e,
  a,
  o,
  n,
  t
), E = ({
  cartId: e,
  products: a,
  loginMethod: t,
  partnerName: o,
  features: n
}) => r(
  "purchase",
  e,
  a,
  o,
  n,
  t
), r = (e, a, t, o, n, c) => {
  const i = {
    currency: "NOK",
    item_revenue: g(t),
    items: v(t, o),
    transaction_id: e === "purchase" ? a : void 0,
    value: f(t)
  };
  return {
    cart_id: a,
    ecommerce: i,
    event: e,
    feature_flags: n,
    login_method: c ?? void 0,
    page_type: "e-commerce",
    traffic_type: "internal"
  };
}, y = (e, a, t) => ({
  event: e,
  feature_flags: a,
  login_method: t,
  page_type: "e-commerce",
  traffic_type: "internal"
}), g = (e) => e.map((a) => a.yearlyPrice).reduce((a, t) => a + t, 0), f = (e) => e.map((a) => a.yearlyPriceWithTax).reduce((a, t) => a + t, 0), v = (e, a) => e.map((t) => L(t, a)), L = (e, a) => {
  var t, o, n, c;
  return {
    affiliation: a.toLocaleLowerCase(),
    discount: e.totalYearlyDiscount,
    item_brand: "storebrand",
    item_category: "privat",
    item_category2: "forsikring",
    item_category3: (t = e.category) == null ? void 0 : t.toLocaleLowerCase(),
    /**
     * Name/ID of promotion, discount or campaign, if relevant.
     * Leaving this undefined for now.
     */
    item_category4: void 0,
    item_category5: (o = e.agreementCode) == null ? void 0 : o.toLocaleLowerCase(),
    item_id: (n = e.coverage) == null ? void 0 : n.toLocaleLowerCase(),
    item_information: (c = e.supplementaryInfo) == null ? void 0 : c.toLocaleLowerCase(),
    item_name: e.name.toLocaleLowerCase(),
    price: e.yearlyPrice,
    quantity: 1
  };
}, u = (e, a) => e.filter(
  (t) => a.some((o) => o === t.productId)
), P = ({
  features: e,
  funnelName: a,
  partner: t,
  loginMethod: o,
  page: n,
  products: c,
  extendedProductInformation: i
}) => _({
  extendedProductInformation: i,
  features: e,
  funnelName: a,
  loginMethod: o,
  page: n,
  partner: t,
  products: c
}), A = ({
  errorMessage: e,
  features: a,
  funnelName: t,
  partner: o,
  loginMethod: n,
  page: c,
  products: i,
  extendedProductInformation: s
}) => _({
  errorMessage: e,
  extendedProductInformation: s,
  features: a,
  funnelName: t,
  loginMethod: n,
  page: c,
  partner: o,
  products: i
}), _ = ({
  funnelName: e,
  errorMessage: a,
  features: t,
  partner: o,
  loginMethod: n,
  page: c,
  products: i,
  extendedProductInformation: s
}) => i == null ? void 0 : i.map((l) => {
  var m;
  return {
    affiliation: o,
    event: "funnel_event",
    event_extension: a,
    feature_flags: t,
    funnel_name: e,
    item_information: l.supplementaryInfo ? l.supplementaryInfo.toLocaleLowerCase() : s == null ? void 0 : s.toLocaleLowerCase(),
    login_method: n,
    product_category_1: "privat",
    product_category_2: "forsikring",
    product_category_3: (m = l.category) == null ? void 0 : m.toLocaleLowerCase(),
    product_name: l.name.toLocaleLowerCase(),
    step_name: c || "ukjent"
  };
});
export {
  k as analyticsAddPaymentInfo,
  w as analyticsAddToCart,
  d as analyticsBeginCheckout,
  E as analyticsPurchase,
  h as analyticsRemoveFromCart,
  C as analyticsUseFeatures,
  p as analyticsViewCart,
  A as analyticsViewError,
  P as analyticsViewPage
};
